import { createSlice } from '@reduxjs/toolkit';
import REDUX_SLICE_NAMES from 'consts/redux-slice-names';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { RootState } from 'redux/store';

interface UrlModel {
  categoriesId: string;
  subCategoriesId: string;
  arrticleId: string;
  isCheckTopic: boolean;
  majorVersion: string;
  minorVersion: string;
}

const initialState: UrlModel = {
  categoriesId: '',
  subCategoriesId: '',
  arrticleId: '',
  isCheckTopic: false,
  majorVersion: '',
  minorVersion: '',
};

export const reduxUrlId = createSlice({
  name: REDUX_SLICE_NAMES.URL_ID,
  initialState,
  reducers: {
    setUrlIdState: (state: UrlModel = initialState, action) => {
      const listProperties = Object.keys(state);
      Object.keys(action.payload).forEach((field) => {
        if (listProperties.includes(field)) {
          state[field as keyof UrlModel] = action.payload[field as keyof UrlModel] as never;
        }
      });
    }
  }
});

const { setUrlIdState } = reduxUrlId.actions;

export const useGetReduxUrlIdState = () => useAppSelector((state: RootState) => state[reduxUrlId.name]);

export const useSetReduxUrlIdState = () => {
  const dispatch = useAppDispatch();
  return {
    setReduxUrl: (fields: Partial<UrlModel>) => {
      dispatch(setUrlIdState(fields))
    }
  }
}

export default reduxUrlId;
